// Makes requests to REST API
export default {
    apiBaseUrl: 'https://jmd-school-rest-api.herokuapp.com/api',
  };
  